import {FormControl, FormGroup} from "@angular/forms";
import {Order, Product, StandardName} from "../../../../store/state/order.state";
import {Subscription} from "rxjs";
import {FormService} from "../../../../umbrella-common/services/form.service";
import {InjectionToken} from "@angular/core";

export interface FormControlHandler {
	buildControls(form: FormGroup, product: Product, params?: any);

	handleSpecificCopying(formService: FormService, controlName: string, srcForm: string, dstForm: string);

	getSubscriptions(formKey: string): Subscription[];

	fillOrder(formService: FormService, order: Order): Order;

	shouldApply(): boolean;
}

export abstract class BaseFormControlHandler implements FormControlHandler {

	private subscriptions: { [standard: string]: Subscription[] } = {};

	abstract buildControls(form: FormGroup, product: Product, params?: any);

	getSubscriptions(formKey: string): Subscription[] {
		return !!this.subscriptions[formKey] ? this.subscriptions[formKey] : [];
	}

	handleSpecificCopying(formService: FormService, controlName: string, srcForm: string, dstForm: string) {
	}

	fillOrder(formService: FormService, order: Order): Order {
		formService.getAllFormKeys().filter(formKey => formService.isSubFormInitialized(formKey)).forEach(formKey => {
			const product = order.products.find(p => p.standard.name === formKey);
			this.fillProduct(formService, formKey, product);

			if (formKey == StandardName.ISO_27001 && order.products.filter(p => [StandardName.ISO_27001, StandardName.ISO_27701].includes(p.standard.name)).length == 2) {
				this.fillProduct(formService, formKey, order.products.find(p => p.standard.name == StandardName.ISO_27701))
			}
		});

		return order;
	}

	protected abstract fillProduct(formService: FormService, srcForm: string, product: Product): void;

	protected addControlIfNotPresent(form: FormGroup, formKey: string, controlNamePrefix: string, control: FormControl) {
		if (!form.controls[controlNamePrefix + formKey]) {
			form.addControl(`${controlNamePrefix}${formKey}`, control);
		}
	}

	protected removeControlIfPresent(form: FormGroup, formKey: string, controlNamePrefix: string) {
		const formControl = form.controls[controlNamePrefix + formKey];
		if (formControl) {
			formControl.setValue(undefined);
			formControl.markAsPristine();
			form.removeControl(controlNamePrefix + formKey);
		}
	}

	protected addSubscription(formKey: string, subscription: Subscription): void {
		if (this.subscriptions[formKey] == null) {
			this.subscriptions[formKey] = [];
		}

		this.subscriptions[formKey].push(subscription);
	}

	shouldApply(): boolean {
		return true;
	}
}

export const COMPANY_GENERAL_INFO_FORM_CONTROL_HANDLERS = new InjectionToken<FormControlHandler>('FormControlHandler');
